<div class="d-flex justify-content-between align-items-center">
  <div class="row w-100">

<div class="w-100 d-flex custom-sm-gap justify-content-between align-xl-items-center align-lg-items-center align-md-items-center align-sm-items-center align-items-start mb-3 flex-xl-row flex-lg-row flex-md-row flex-column ">
  <div class="w-100 justify-content-between  d-flex custom-sm-gap flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column  align-xl-items-center align-lg-items-center align-md-items-center align-sm-items-center align-items-start">
    <div class="d-flex  flex-xl-row  flex-lg-row  flex-md-row flex-sm-row  flex-column align-items-xl-center align-items-md-center align-items-lg-center align-items-sm-center align-items-start custom-sm-gap">
    <div  class="dropdown-container">
      <ng-select class="custom-user-select" appearance="outline" [clearable]="false" (change)="changed()" [(ngModel)]="selectedAccount" [searchable]="false">
      <ng-option *ngFor="let acc of accList" value="{{acc.relationCode}}">
		            <span *ngIf="translate.currentLang === 'en'">
                   ({{acc.relationCode}})             
                  {{ acc.clientNameEn }}
                    — {{ acc.accountTypeEn }}
                        </span>
                        <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                           ({{acc.relationCode}})             
                          <span>{{ acc.clientNameAr }}</span>
                          <span>{{ acc.accountTypeAr }}</span>
                        </span>      
      </ng-option>
    </ng-select>
    </div>
    <!-- <div class="dropdown">
      <button class="btn btn-primary" style="padding-block: 5px;" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fas fa-ellipsis-h"></i>
      </button>
      <div class="dropdown-menu">
        <button class="dropdown-item" type="button" [routerLink]="'/changePassword'">{{'change-password'|translate}}</button>
      </div>
    </div> -->
    <small class="dormint  text-start  bg-warning" [popoverClass]="'dormint-content'" triggers="mouseenter:mouseleave" [ngbPopover]="dormintContent" *ngIf="this.accObject.Isdormint">{{'dormant-acc'|translate}}</small>
    <ng-template #dormintContent>{{'dormant-hint' | translate}}</ng-template>

<div class="mx-1 d-flex" *ngIf="selectedAccount">
      <button class="btn btn-sm btn-outline-primary mx-1 action-btn shadow-none" (click)="openStatement()">
        <i class="icon fa fa-file-contract px-1"></i>
        {{'my-statement'|translate}}
      </button>
      <button class="btn btn-sm btn-outline-primary mx-1 action-btn shadow-none" (click)=" openInvoice()">
        <i class="icon fa fa-receipt px-1"></i>
        {{'my-invoices'|translate}}
      </button>
      <button class="btn btn-sm btn-outline-secondary mx-1 action-btn shadow-none" (click)="downloadPDF()">
        <i class="icon fa fa-print px-1" *ngIf="!isLoadingPdf"></i>
        <div class="spinner-border text-secondary loading-icon" *ngIf="isLoadingPdf" role="status">
          <span class="sr-only"></span>
        </div>
      </button>
    </div>
  </div>
  <div class="p-1 mx-2">
    <span class="badge rounded-pill" [ngStyle]="getColor">{{(translate.currentLang=='en')?accObject?.accountTypeEn:accObject?.accountTypeAr}}</span>
  </div>
</div>
    
</div>